import { GridFiltersWebComponent } from './component/GridFiltersWebComponent';
import { WEB_COMPONENT_GRID_FILTERS } from '../../webcomponents.constants';

export { GridFiltersWebComponent };

window.customElements.define(WEB_COMPONENT_GRID_FILTERS, GridFiltersWebComponent);
